import { useNavigate } from 'react-router-dom';

import Navbar1 from 'assets/images/navbar_1.png';
import Navbar2 from 'assets/images/navbar_2.png';
import Navbar3 from 'assets/images/navbar_3.png';
import Navbar4 from 'assets/images/navbar_4.png';
import Navbar5 from 'assets/images/navbar_5.png';
import useAudio from 'hooks/useAudio';

export default function Navbar() {
  // hooks
  const navigate = useNavigate();
  const { handlePlay } = useAudio('/sounds/click_sound.mp3');

  const handleMenu = (path: string) => {
    navigate(path);
    handlePlay();
  };

  const NAV_MENU = [
    { id: 'points-earned', src: Navbar1, path: '/points-earned' },
    { id: 'earn-more-points', src: Navbar2, path: '/earn-more-points' },
    { id: 'my-asset-status', src: Navbar3, path: '/my-asset-status' },
    { id: 'profile', src: Navbar4, path: '/profile' },
    { id: 'spotlight', src: Navbar5, path: '/spotlight' },
  ];

  return (
    <nav className="absolute bottom-0 flex h-[96px] w-full items-center justify-between gap-[15px] bg-[url(assets/images/nav_background.png)] bg-cover pl-[24px] pr-[30px]">
      {NAV_MENU.map((menu) => (
        <button key={menu.id} onClick={() => handleMenu(menu.path)}>
          <img src={menu.src} className="h-[73px] w-[70px]" />
        </button>
      ))}
    </nav>
  );
}
